const flatMenuLinks = (menu, addCurrentLevelItem = true) => menu.reduce((acc, submenu) => {
    const { children } = submenu;
    if (!children) {
        return {};
    }
    const deepLevelLinks = flatMenuLinks(children, false);
    return acc.concat([...(addCurrentLevelItem ? [submenu] : []), ...children, ...deepLevelLinks]);
}, []);

export { flatMenuLinks };
//# sourceMappingURL=menu.js.map
